/**
 * Owner: Masa Bayu
 * File: library-wishlist.ts
 * Date:Time: 2026-09-15 23:21
 * Description: T4 wishlist — saved titles; never implies entitlement.
 */
import { assertNoForbiddenFoundationKey } from './authority';
import { createQxreadId } from './id';
import { assertTimestamp, assertValidId } from './guards';
import { assertT4E1SecurityIntact } from './library-security';
export const QXREAD_WISHLIST_ITEM_STATES = ['active', 'purchased_converted', 'removed'];
export function createWishlistItem(options) {
    assertNoForbiddenFoundationKey(options, 'QXRead wishlist item');
    assertT4E1SecurityIntact();
    assertValidId(options.accountId, 'QXRead wishlist accountId');
    assertValidId(options.publicationId, 'QXRead wishlist publicationId');
    if (typeof options.title !== 'string' || options.title.trim().length === 0) {
        throw new Error('QXRead wishlist title is required');
    }
    const wishlistItemId = options.wishlistItemId !== undefined ? options.wishlistItemId : createQxreadId('qxrdwish');
    assertValidId(wishlistItemId, 'QXRead wishlistItemId');
    const createdAt = options.createdAt ?? new Date().toISOString();
    assertTimestamp(createdAt, 'QXRead wishlist createdAt');
    return Object.freeze({
        wishlistItemId,
        accountId: options.accountId,
        publicationId: options.publicationId,
        title: options.title.trim(),
        state: 'active',
        createdAt,
        updatedAt: createdAt,
    });
}
export function wishlistImpliesEntitlement(_item) {
    return false;
}
export function markWishlistPurchasedConverted(item) {
    if (item.state !== 'active') {
        throw new Error('QXRead wishlist convert requires an active wishlist item');
    }
    return Object.freeze({
        ...item,
        state: 'purchased_converted',
        updatedAt: new Date().toISOString(),
    });
}
export function removeWishlistItem(item) {
    return Object.freeze({
        ...item,
        state: 'removed',
        updatedAt: new Date().toISOString(),
    });
}
//# sourceMappingURL=library-wishlist.js.map